// extracted by mini-css-extract-plugin
export default {"container":"ride-data-info__container___YFscF"};